import BaseCollection from "lib/collection";
import BaseModel from "lib/model";

const AddressModel = BaseModel.extend({
    props: {
        _id: "objectId",
        display_name: { type: "string", required: true },
        line1: { type: "string", required: true },
        line2: "string",
        line3: "string",
        line4: "string",

        city: "string",
        state: "string",
        zip: "string",
        phone: "string",
        country: {
            type: "string",
            default: "United States",
        },

        billing_code: "string",
        shipping_code: "string",

        warehouse: "objectId",

        default_billing: { type: "boolean", required: true, default: false },
        default_shipping: { type: "boolean", required: true, default: false },
    },
});

export default BaseCollection.extend({
    mainIndex: "_id",
    model: AddressModel,
});
